<template>
  <div
    :class="scrolledToTop ? 'h-28' : 'h-20 shadow'"
    class="bg-white px-6 relative flex items-center w-full transition-all duration-300 ease-in-out shadow-sm"
  >
    <!-- Logo -->
    <div
      :class="scrolledToTop ? 'h-28' : 'h-20'"
      class="flex flex-col items-center justify-center w-32 rr-6 py-4 flex-shrink-0 transition-all duration-300 ease-in-out"
    >
      <div
        class="bg-no-repeat bg-center bg-contain flex items-center justify-center flex-shrink-0 w-full h-full"
        :style="[{ backgroundImage: 'url(' + settings.logo + ')' }]"
      >
        <span class="hidden">{{ settings.profile_title }}</span>
      </div>
    </div>

    <div
      :style="{ width: 'calc(100vw - 10rem)' }"
      :class="scrolledToTop ? 'h-28' : 'h-20'"
      class="transition-all duration-300 ease-in-out relative"
    >
      <div
        :class="scrolledToTop ? 'h-8' : 'h-0 opacity-0 pointer-events-none'"
        class="transition-all duration-300 ease-in-out flex justify-end items-center flex-shrink-0"
      >
        <div
          v-if="user"
          class="pl-4 pr-8 border-l border-truegray-700 space-x-2 flex items-center justify-center hover:text-primary cursor-pointer transition-all duration-300"
          @click="triggerLogOut"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          Logout
        </div>

        <div
          v-if="!user"
          class="bg-black hover:bg-white text-white hover:text-primary px-6 space-x-2 flex items-center justify-center hover:text-primary cursor-pointer transition-all duration-300 h-8"
          @click="showLoginModal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
            />
          </svg>
          Login
        </div>
        <div
          v-if="user"
          class="bg-truegray-700 text-white hover:text-primary hover:bg-white px-6 space-x-2 flex items-center justify-center hover:text-primary cursor-pointer transition-all duration-300 h-8"
          @click="openAdminMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
            />
          </svg>
          Admin Panel
        </div>
        <div
          class="bg-primary text-white hover:bg-white px-6 space-x-2 flex justify-center items-center hover:text-primary cursor-pointer transition-all duration-300 h-8"
          @click="showSubscribeModal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
            />
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
          </svg>
          Subscribe
        </div>
      </div>

      <div
        :style="{ width: 'calc(100vw - 10rem)' }"
        :class="scrolledToTop ? 'bg-truegray-100' : 'bg-white'"
        class="h-20 w-full transition-all duration-300 ease-in-out"
      >
        <!-- Menu Content -->
        <div class="w-full overflow-visible flex h-20 relative">
          <!-- Scroll button -->
          <div class="h-20 flex flex-col ml-2 items-center justify-center">
            <div
              v-if="isOverflowing && !smartMenuActive"
              :class="scrolledToLeft ? 'opacity-0' : ''"
              class="flex flex-col justify-center items-center cursor-pointer text-white hover:text-primary h-6 w-6 border-2 border-primary rounded-full bg-primary hover:bg-white transition-all duration-300 ease-in-out"
              @click="scroll('left')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>

          <!-- GUEST MENU -->
          <div
            id="tenantMenu"
            :style="{ maxWidth: 'calc(100vw - 16rem)' }"
            class="overflow-hidden transition-all duration-300 flex items-center px-6 w-full h-20 z-20"
          >
            <ul
              id="tenantMenuContent"
              class="overflow-x-auto no-scrollbar relative transition duration-150 ease-in-out flex items-center space-x-4 w-full h-20"
            >
              <!-- DEFAULT PAGES -->
              <li
                class="menu-item text-center px-2 w-full cursor-pointer hover:text-primary flex-shrink-0"
                :class="[
                  { active: 'Home' === activeMenuItem },
                  'Home' === activeMenuItem ? 'text-primary font-bold' : '',
                ]"
                @click="pushRoute('Home')"
              >
                Home
              </li>

              <!-- DYNAMIC PAGES - POSTS OBJECT IS NOW PUSHED MANUALLY INTO THIS ARRAY -->
              <li
                v-for="(parent, i) in filteredMenu"
                :key="i"
                :ref="'menu-item' + i"
                :class="[
                  {
                    'text-primary font-bold':
                      parent.id == activeMenuItem ||
                      parent.id === activeMenuParent,

                    'ddActive': parent.id === activeDropdown,
                  },
                ]"
                class="menu-item text-center flex-shrink-0 w-full flex flex-wrap items-center group overflow-visible relative"
              >
                <!-- Dropdown Parent -->
                <div
                  v-if="parent.children.length >= 1"
                  :id="'parent-' + parent.id"
                  class="w-full cursor-pointer hover:text-primary flex-shrink-0 px-2"
                  @mouseover="handleDDHover(parent)"
                  @mouseleave="handleMouseLeaveParent(parent)"
                >
                  <div
                    class="w-full flex items-center justify-center h-20"
                    :class="[
                      ,
                      activeDropdown === parent.id ? 'text-primary' : '',
                    ]"
                  >
                    <span class="mr-2 clamp-2">{{ parent.title }}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="lg:ml-auto h-5 w-5 flex-shrink-0"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                </div>

                <!-- Standard pages -->
                <div
                  v-else
                  :class="[
                    parent.page_type === 2
                      ? 'group relative cursor-not-allowed'
                      : 'cursor-pointer',
                  ]"
                  class="w-full flex items-center space-x-1 justify-center hover:text-primary px-2"
                  @click="pushToPageRoute(parent)"
                >
                  <svg
                    v-if="parent.page_type === 1"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-3 w-3 opacity-50"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                  <!-- If parent is a label but has no children, alert the admin about the mistake -->
                  <svg
                    v-if="parent.page_type === 2 && user"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="h-3 w-3 opacity-50"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                    />
                  </svg>
                  <div v-if="parent.page_type === 2 && user" :class="infoClass">
                    You have created a label with no dropdown items inside.
                  </div>
                  <span>{{ parent.title }}</span>
                </div>
              </li>

              <li
                v-if="settings.enabled_contact"
                class="menu-item w-full cursor-pointer hover:text-primary flex-shrink-0 px-2"
                :class="[
                  { active: 'posts' === activeMenuItem },
                  'posts' === activeMenuItem ? 'bg-truegray-100' : '',
                ]"
                @click="contact()"
              >
                Contact
              </li>
            </ul>
          </div>

          <!-- Scroll button -->
          <div class="h-20 flex flex-col mr-2 items-center justify-center">
            <div
              v-if="isOverflowing && !smartMenuActive"
              :class="scrolledToRight ? 'opacity-0' : ''"
              class="flex flex-col justify-center items-center cursor-pointer text-white hover:text-primary h-6 w-6 border-2 border-primary rounded-full bg-primary hover:bg-white transition-all duration-300 ease-in-out"
              @click="scroll('right')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Smart menu trigger -->
      <div
        v-if="isOverflowing"
        class="hidden lg:block absolute top-full text-xs right-0 bg-black hover:bg-primary text-white py-2 px-8 cursor-pointer z-20"
        @click="showFullMenu"
      >
        See full menu
      </div>
    </div>

    <!-- dropdown container -->
    <div
      :class="[
        scrolledToTop ? 'top-28' : 'top-20',
        activeDropdown === null ? 'pointer-events-none' : '',
      ]"
      class="absolute left-0 w-full h-full z-10"
    >
      <div
        v-for="(parent, i) in filteredMenu"
        :id="'dd-' + parent.id"
        :key="i"
        :class="[
          activeDropdown === parent.id ? '' : 'opacity-0 pointer-events-none',
        ]"
        class="absolute transition-opacity duration-300"
        :style="[
          { width: '300px' },
          { maxWidth: '300px' },
          { minWidth: ddWidth },
          { left: ddPosX + 'px' },
        ]"
        @mouseleave="closeDD"
      >
        <div
          v-if="parent.children.length >= 1"
          class="w-full cursor-pointer flex-shrink-0 px-2"
        >
          <!-- Dropdown Children -->
          <div
            class="sub-menu bg-white w-full px-2 transition-all duration-300 border-t-2 border-primary shadow"
          >
            <ul class="w-full space-y-4 py-8">
              <li
                v-if="parent.page_type !== 2 && !parent.static"
                class="px-6 transition-all duration-300 w-full flex items-center space-x-1 text-left cursor-pointer hover:text-primary"
                :class="{
                  'text-primary font-bold': activeMenuItem === parent.id,
                }"
                @click="pushToPageRoute(parent)"
              >
                <span>{{ parent.title }}</span>
                <svg
                  v-if="parent.page_type === 1"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 opacity-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </li>
              <li
                v-for="(child, j) in parent.children"
                :key="j"
                class="flex items-center text-left space-x-1 px-6 transition-all duration-300 w-full cursor-pointer hover:text-primary"
                :class="{
                  'text-primary font-bold':
                    activeMenuItem === child.id ||
                    child.title.toLowerCase() ==
                      (typeof activePostsItem === 'string'
                        ? activePostsItem.toLowerCase()
                        : ''),
                }"
                @click="pushToPageRoute(child)"
              >
                <span class="clamp-3">{{ child.title }}</span>
                <svg
                  v-if="child.page_type === 1"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 opacity-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../../../../js/mixins/shared.js'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [shared],

  data() {
    return {
      isOverflowing: false,
      activeMenuItem: 'Home',
      activeDropDownItem: null,
      activePostsItem: null,
      activeMenuParent: null,
      activeDropdown: null,
      ddPosX: 0,
      ddWidth: 0,
      scrolledToTop: true,
      scrolledToLeft: true,
      scrolledToRight: false,
      smartMenuActive: false,

      infoClass:
        'absolute left-12 label-error w-64 z-50 border border-truegray-300 rounded p-4 opacity-0 transition-all duration-300 transform pointer-events-none shadow group-hover:opacity-100 bg-white',
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      user: 'shared/getUser',
      menu: 'shared/getMenu',
    }),

    filteredMenu() {
      let menu = this.menu
        .filter((item) => item.status === 1)
        .map((item) => ({
          ...item,
          children: item.children.filter((child) => child.status === 1),
        }))

      // Add non dynamic page object for posts. Id is 0 for no conflicts. Lean into - numbers if more need adding.
      let connectionsObject = {
        title: 'Connections',
        id: -1,
        external_link: false,
        status: 1,
        page_type: 99,
        children: [],
        route: 'connections',
      }

      // Static true changes the parent appearing in the dropdown container
      let postsObject = {
        title: 'Posts',
        id: 0,
        external_link: false,
        status: 1,
        page_type: 99,
        static: true,
        children: [
          {
            title: 'News',
            external_link: false,
            // id: 0,
            page_type: 99,
            status: 1,
            postsPage: true,
            postsRoute: 'news',
            parent_id: 0,
          },
          {
            title: 'Events',
            external_link: false,
            // id: 0,
            page_type: 99,
            status: 1,
            postsPage: true,
            postsRoute: 'events',
            parent_id: 0,
          },
          {
            title: 'Jobs',
            external_link: false,
            // id: 0,
            page_type: 99,
            status: 1,
            postsPage: true,
            postsRoute: 'jobs',
            parent_id: 0,
          },
        ],
      }

      // Add new object to the beginning of the array
      menu.unshift(connectionsObject)
      menu.unshift(postsObject)

      return menu
    },
  },

  watch: {
    $route: {
      immediate: true,

      handler(to) {
        if (to.name === 'Home') {
          this.activeMenuItem = 'Home'
          this.activePostsItem = null
        } else if (to.path.includes('/page/')) {
          const idString = to.path.split('/').pop()
          const id = Number(idString)
          this.activeMenuItem = id
          this.activePostsItem = null

          // Find the page with the id of activeMenuItem
          const page =
            this.filteredMenu.find((parent) => parent.id === id) ||
            this.filteredMenu
              .flatMap((parent) => parent.children)
              .find((child) => child.id === id)

          // Set activeMenuParent to parent_id if it exists
          if (page && page.parent_id) {
            this.activeMenuParent = Number(page.parent_id)
          } else {
            this.activeMenuParent = null
          }
        } else if (to.path.includes('/posts')) {
          this.activeMenuItem = 0
          if (to.query.category) {
            this.activePostsItem = to.query.category
          }
        } else {
          this.activeMenuItem = null
          this.activePostsItem = null
        }
      },
    },
  },

  mounted() {
    setTimeout(() => {
      this.checkOverflow()
    }, 10)

    EventBus.$on('smartMenuStateChanged', (active) => {
      this.$set(this, 'smartMenuActive', active)
    })

    this.checkWindowPosition()
  },

  methods: {
    triggerLogOut() {
      EventBus.$emit('showModal', 'logout')
    },

    pushToPosts(type) {
      if (this.$router.history.current.name === 'Posts') {
        const currentRoute = this.$router.currentRoute
        const desiredPath = '/posts'
        const desiredType = type
        const currentType = currentRoute.query.category

        if (currentRoute.path !== desiredPath || currentType !== desiredType) {
          const updatedQuery = { ...currentRoute.query, category: desiredType }
          this.$router.replace({ ...currentRoute, query: updatedQuery })
        }
      } else {
        this.$router.push({
          path: '/posts?category=' + type,
          params: { type: type },
        })
      }
      EventBus.$emit('closeResourceModals')
      EventBus.$emit('posts_params_changed')
      EventBus.$emit('modal_state_changing', false)
    },

    pushRoute(route) {
      if (route === 'Posts' && this.$router.currentRoute.name === route) {
        EventBus.$emit('NonManagerRouteClicked')
        EventBus.$emit('showSmartMenu', false)
        EventBus.$emit('reload_posts_to_published')
      }
      if (this.$router.currentRoute.name !== route) {
        EventBus.$emit('NonManagerRouteClicked')
        EventBus.$emit('showSmartMenu', false)
        this.$router.push({ name: route })
      }
      EventBus.$emit('closeResourceModals')
      EventBus.$emit('closeMobileMenu')
      EventBus.$emit('modal_state_changing', false)
    },

    pushToPageRoute(item) {
      if (item.page_type === 2) {
        return
      }
      let url = item.external_link
      if (item.external_link && this.validateURL(url)) {
        if (!this.validateURLProtocol(url)) {
          url = this.updateURLWithProtocol(url)
        }
        window.open(url, '_blank')
        return
      }
      let id = item.id
      this.$set(this, 'activeDropdown', null)
      EventBus.$emit('NonManagerRouteClicked')
      if (item.postsPage) {
        this.pushToPosts(item.postsRoute)
      } else if (item.route) {
        this.$router.push({ path: '/' + item.route })
      } else {
        this.$router.push({ path: '/page/' + id })
      }
      EventBus.$emit('closeResourceModals')
      EventBus.$emit('showSmartMenu', false)
      EventBus.$emit('closeMobileMenu')
      EventBus.$emit('modal_state_changing', false)
    },

    contact() {
      EventBus.$emit('showModal', 'contact')
      EventBus.$emit('closeMobileMenu')
    },

    checkOverflow() {
      let overflowMenu = document.getElementById('tenantMenu')
      let content = document.getElementById('tenantMenuContent')

      if (overflowMenu) {
        let overflowing = overflowMenu.scrollWidth < content.scrollWidth
        this.$set(this, 'isOverflowing', overflowing)
      }
    },

    scroll(direction) {
      let overflowMenu = document.getElementById('tenantMenu')
      let content = document.getElementById('tenantMenuContent')

      let scrollWidth = content.scrollWidth
      let menuWidth = overflowMenu.clientWidth
      // let currentScroll = overflowMenu.scrollY + overflowMenu.innerHeight;

      if (direction === 'left') {
        content.scrollBy(-250, 0)
      } else {
        content.scrollBy(250, 0)
      }

      // Are we scrolled to left or right? Hide arrows. Set timeout to allow smooth scroll to play out
      setTimeout(() => {
        let scrollLeft = content.scrollLeft
        if (scrollLeft <= 3) {
          this.$set(this, 'scrolledToLeft', true)
        } else {
          this.$set(this, 'scrolledToLeft', false)
        }
        if (scrollLeft + menuWidth >= scrollWidth) {
          this.$set(this, 'scrolledToRight', true)
        } else {
          this.$set(this, 'scrolledToRight', false)
        }
      }, 300)
    },

    checkWindowPosition() {
      window.onscroll = () => {
        if (window.scrollY <= 10) {
          this.$set(this, 'scrolledToTop', true)
        } else {
          this.$set(this, 'scrolledToTop', false)
        }
      }
    },

    // Smart menu Methods
    showFullMenu() {
      EventBus.$emit('showSmartMenu', true)
    },

    showSubscribeModal() {
      EventBus.$emit('showModal', 'subscribe')
    },

    showLoginModal() {
      EventBus.$emit('showModal', 'login')
    },

    openAdminMenu() {
      EventBus.$emit('showSmartMenu', true)
      EventBus.$emit('openAdminMenu')
    },

    handleDDHover(parent) {
      let parentEl = document.getElementById('parent-' + parent.id)
      let dd = document.getElementById('dd-' + parent.id)
      let parent_position = parentEl.getBoundingClientRect()
      let position = parent_position.x - 15
      if (dd && parent) {
        this.$set(this, 'ddPosX', position)
        this.$set(this, 'ddWidth', parent_position.width)
        this.$set(this, 'activeDropdown', parent.id)
      }
    },

    handleMouseLeaveParent(parent) {
      let element = document.getElementById('dd-' + parent.id)
      if (element.parentNode.querySelector(':hover') === element) {
        //Mouse is inside element
      } else {
        this.closeDD()
      }
    },

    closeDD() {
      this.$set(this, 'activeDropdown', null)
    },
  },
}
</script>

<style scoped>
.scroll-text {
  font-size: 8px;
}

.menu-item {
  width: max-content;
  /* max-width: 175px; */
}

.clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.label-error {
  top: 50%;
  transform: translateY(-50%);
}

#tenantMenu,
#tenantMenuContent {
  scroll-behavior: smooth;
}
</style>
